/*
 *
 *  * Copyright (c) 2018-2019 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import { default as React, createContext, useState, ReactNode } from "react";
import { ToastType } from "../components/common/Toast/Toast";

interface Props {
  children: ReactNode;
}
export interface ToastContextValue {
  isDisplayed: boolean;
  message: string;
  type: ToastType;
  displayToast: Function;
}
export const ToastContext = createContext<ToastContextValue>({
  isDisplayed: false,
  message: "",
  type: "success",
  displayToast: () => null,
});

const ToastProvider = ({ children }: Props) => {
  let timeout: any;
  const [isDisplayed, setIsDisplayed] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [type, setType] = useState<ToastType>("success");

  const displayToast = (message: string, type: ToastType) => {
    clearTimeout(timeout);
    setType(type);
    setMessage(message);
    setIsDisplayed(true);
    timeout = setTimeout(() => setIsDisplayed(false), 5000);
  };

  return <ToastContext.Provider value={{ isDisplayed, message, type, displayToast }}>{children}</ToastContext.Provider>;
};

export default ToastProvider;
